module.exports = __webpack_public_path__ + "static/media/mobile.e25ae7b6df.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/mobile.png
// module id = 6427
// module chunks = 0